import React, { useState } from "react";
import { FormFieldSet } from "../../../../../components";
import { PropsTable, RADIOLIST_PROPS } from "./Props/Props";

const CATEGORIES = {
  core: { label: "Core", color: "#EFF6FF", textColor: "#1D4ED8" },
  display: { label: "Display", color: "#F0FDF4", textColor: "#15803D" },
  behavior: { label: "Behavior", color: "#FFFBEB", textColor: "#B45309" },
};

const RadioList = () => {
  const [radioValue, setRadioValue] = useState("");
  const handleRadioChange = (event) => {
    setRadioValue(event.target.value);
  };

  const [selectedValue, setSelectedValue] = useState("non-billable");
  const handleSelection = (event) => {
    setSelectedValue(event.target.value);
  };
  return (
    <div>
      <div className="grid grid-cols-4 gap-5 my-5 mb-30">
        <div>
          <FormFieldSet
            name={"er"}
            type="radio"
            size="md"
            title="Select"
            placeholder="Enter Zip Code"
            options={[
              { label: "Billable", value: "billable" },
              { label: "Non-Billable", value: "non-billable" },
            ]}
            value={radioValue}
            onChange={handleRadioChange}
          />
        </div>
        <div>
          <FormFieldSet
            type="radio"
            size="md"
            title="Selected Value"
            placeholder="Enter Zip Code"
            options={[
              { label: "Billable", value: "billable" },
              { label: "Non-Billable", value: "non-billable" },
            ]}
            value={selectedValue}
            onChange={handleSelection}
          />
        </div>
      </div>

      <PropsTable
        data={RADIOLIST_PROPS}
        title="radio — Props Reference"
        typeLabel='type="radio"'
        categories={CATEGORIES}
        />
    </div>
  );
};

export default RadioList;
